// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgScienceSunSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.749 4a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V1.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5zm.001 18.561c0 .242-.224.438-.5.438h-.5c-.276 0-.5-.196-.5-.438v-2.625c0-.241.224-.437.5-.437h.5c.276 0 .5.196.5.438zM6.52 6.874a.5.5 0 0 1-.706 0L4.046 5.106a.5.5 0 0 1 0-.707l.353-.354a.5.5 0 0 1 .708 0l1.767 1.768a.5.5 0 0 1 0 .707zM20 18.938c.17.17.15.468-.044.663l-.354.353c-.195.196-.492.215-.663.045l-1.856-1.856c-.17-.171-.151-.468.044-.663l.354-.354c.195-.195.492-.215.663-.044zM17.126 6.52a.5.5 0 0 1 0-.707l1.768-1.768a.5.5 0 0 1 .707 0l.353.353a.5.5 0 0 1 0 .708l-1.767 1.767a.5.5 0 0 1-.707 0zM5.062 19.999c-.171.17-.468.15-.663-.044l-.354-.354c-.195-.195-.215-.492-.044-.663l1.856-1.856c.171-.17.468-.151.663.044l.354.354c.195.195.215.492.044.663zm14.442-8.25c0-.276.196-.5.437-.5h2.625c.242 0 .438.224.438.5v.5c0 .277-.196.5-.438.5h-2.625c-.241 0-.437-.223-.437-.5zm-18.067 1c-.242 0-.438-.223-.438-.5v-.5c0-.276.196-.5.438-.5h2.625c.241 0 .437.224.437.5v.5c0 .277-.196.5-.437.5zM6 12a6 6 0 1 1 12 0 6 6 0 0 1-12 0z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgScienceSunSolid;
